import React from 'react';

import logo from '../assets/images/logo_HAiGrey.svg';
import bg from '../assets/images/bg_wave.png';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

import Copyright  from '../components/copyright/Copyright';

const FullImage = styled('img')({
  width: '100%',
  maxWidth: '100%'
})

const MinimalLayout = (props) => { 
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        background: `url(${bg}) no-repeat center bottom`,
        borderTop: `8px solid ${theme.palette.primary.main}`,
        boxSizing: 'border-box'
      }}>
      <Container
        maxWidth="false"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          flex: '1 0 0',
          // maxWidth: '348px'
        }}>

        <Box sx={{ width: '160px', marginBottom: '48px', marginTop: '-120px' }}>
          <FullImage src={logo} alt="HAi Report" />
        </Box>

        <Box sx={{ width: '100%' }}>
          {props.children}
        </Box>
        
      </Container>
      <Copyright  style={{ color:'#fff', textAlign: 'center' }} />
    </Box>
  );
}

export default MinimalLayout;